export default __webpack_public_path__ + "static/media/bag-primary.6c66490e.svg";